const $ = window.$
let $window = $(window)

import React from 'react'
import {createRoot} from "react-dom/client"
import {trackEventSP} from 'js/studios/shared/tracking'
import {StarRating} from 'js/studios/shared/star_rating'
import {ExpandMoreIcon} from 'js/studios/shared/svg_icons'
import {FormattedText} from 'js/studios/shared/utils'
import moment from 'moment'

// sets fancybox params globally so all attachments appear the same way
window.cm.fancyboxParams = {
  'transitionIn'  : 'elastic',
  'transitionOut' : 'elastic',
  'speedIn'  :  200,
  'speedOut' :  200,
  'overlayColor' : '#fff',
  'overlayOpacity' : '0.9',
  'padding' : 0,
  'helpers' :  {
    'title' : {
      'type' : 'over',
      'position' : 'bottom'
    },
    'thumbs' : {
      'width' : 100,
      'height'  : 100
    }
  },
  'beforeShow' : function(){
    trackEventSP('click_expand_image', 'browse')
    this.title = $(this.element).find('img').attr('alt')
    if ( ! this.title ) {
      this.title = $(this.element).parent().find('span.example_card_attributes').html()
    }
  }
}

window.$(document).ready(function(){
  //Affixes service page nav to top of page when page is scrolled past hero area
  if ($('#category_nav').length){
    var stickyNav = $('#category_nav'),
        elTop = stickyNav.offset().top

    $window.scroll(function() {
      stickyNav.toggleClass('stuck', $window.scrollTop() > elTop)
    })
  }

  //Controls for the tabbed navigation for project cards
  $('.tab_menu_item').on('click', function(e){
    e.preventDefault()
    let $chosenItem = $(e.currentTarget),
        chosenValue = $chosenItem.attr('data-range')
    $chosenItem.siblings().removeClass('active')
    $('.tabbed_menu_cards .card_container.visible').removeClass('visible')
    $chosenItem.addClass('active')
    $('.example_cards').find("[data-range-set='" + chosenValue + "']").addClass('visible')
    trackEventSP('click_tab_in_tab_slideshow', 'browse', {
      'selected_item': chosenValue
    })
  })

  //Controls for the horizontal scroll slideshow for project cards
  $('.scroll_arrow').on('click', function(){
    let $activeSlideshow = $(this).closest('.horizontal_slideshow').find('.slideshow_contents')
    let currentPosition = $activeSlideshow.scrollLeft()
    trackEventSP('click_scroll_in_scroll_slideshow', 'browse')
    if ($(this).hasClass('left')){
      $activeSlideshow.animate({ scrollLeft: currentPosition - 400 }, 500)
    } else {
      $activeSlideshow.animate({ scrollLeft: currentPosition + 400 }, 500)
    }
  })

  //FAQ Open and close
  $('.question_expand').on('click', function(e){
    e.preventDefault()
    if(!$(this).parents('.question_container').hasClass('is_open')){
      trackEventSP('click_expand_faq_question', 'browse', {
        'label': $(this).attr('title')
      })
    }
    $(this).parents('.question_container').toggleClass('is_open')
  })

  //Tracking for sticky nav clicks
  $('.service_nav_link').on('click', function(e){
    e.preventDefault()
    let $title = $(this).attr('title')
    trackEventSP('click_category_subnav_link', 'browse',{
      'label': $title
    })
  })

  //Fancybox bindings, since we can't use the React utility yet.
  $('[data-fancybox]').fancybox(window.cm.fancyboxParams)

  // rednder the reviews via React if present
  if (window.cm.categoryReviews) {
    createRoot(document.getElementById('reviews_wrapper')).render(<ServicePageReviews reviews={window.cm.categoryReviews}/>)
  }
})

class ServicePageReviews extends React.Component {

  render(){
    let reviews = this.props.reviews.map(function(review){
      return <Review key={review.id} review={review} />
    })

    return(
      <section className="reviews_list">
        {reviews}
      </section>
    )
  }
}

class Review extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      'expanded': false
    }
  }

  toggleLength(e){
    e.preventDefault()
    this.setState({'expanded': this.state.expanded !== true})
  }

  render(){
    let review = this.props.review
    let reviewDate = moment.unix(review.createdAt)
    let photosHTML = review.finalPhotos.map((photo, index) => (
        <div key={photo.id} className="image_item">
          <img loading="lazy" className="image_thumbnail" src={photo.smallUrl} data-fancybox data-fancybox-href={photo.fullUrl} alt={review.projectName + " " + (index + 1)}/>
        </div>
    ))

    return (
      <div className="review_item">
        <div className="review_info">
          <div className="project_info">
            <div className="customer_name">
              <h4>{review.customerName}</h4>
            </div>
            <StarRating rating={review.rating} />
            <div className="review_category">
              <h5>{review.projectName}</h5>
            </div>
            <div className="review_date">
              <p>{reviewDate.format("M/D/YY")}</p>
            </div>
          </div>
        </div>

        <div className={this.state.expanded ? "review_contents expanded" : "review_contents"}>

          <div className="review_photos expandable_images_container">
            {photosHTML}
          </div>
          <div className="overflow_gradient"></div>
          <div className="review_details">
            <FormattedText>{review.comment}</FormattedText>
            <div className="review_breakdown">
              <div className="breakdown_item">
                <h5>Timeliness</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.timelinessScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Expertise</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.qualityScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Communication</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.communicationScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Shipping/Delivery</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.shippingScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Professionalism</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.professionalismScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Value</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.valueScore} />
                </div>
              </div>
            </div>
          </div>
          <a className="review_contents_toggle" onClick={this.toggleLength.bind(this)}>Continue Reading <span><ExpandMoreIcon width="15" height="15" /></span></a>
        </div>
      </div>
    )
  }
}
